import { Box, type SxProps } from '@mui/material';
import React from 'react';

import { spaces } from '../../../../assets/styles/themes/tokens';
import useCardDimensions from '../../../../utils/useCardDimensions';
import useScreenSize from '../../../../utils/useScreenSize';

const SearchResultsContainer: React.FC<{ customSx?: SxProps }> = (props) => {
	const { isXsScreen } = useScreenSize();
	const cardDimensions = useCardDimensions();

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				gap: isXsScreen ? spaces.sm : spaces.md,
				maxWidth: cardDimensions.desktop.maxWidth,
				marginX: 'auto',
				...props.customSx,
			}}
		>
			{props.children}
		</Box>
	);
};

export default SearchResultsContainer;
